"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryCard = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var Title_1 = require("../../atoms/Typography/Title");
var Button_1 = require("../../atoms/Button/Button");
var utils_1 = require("../../../utils/utils");
var StyledCategoryCard = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  padding: ", ";\n  border-radius: ", "px;\n  background: ", ";\n  min-height: 229px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .category-card-icon {\n    margin-top: 15px;\n    svg path {\n      fill: ", ";\n    }\n  }\n  .category-content {\n    h4 {\n      font-size: 20px;\n      margin-bottom: 22px;\n    }\n  }\n  button {\n    display: flex;\n    align-items: center;\n    margin: 0 auto;\n    * {\n      margin: 0px;\n      color: ", ";\n      font-weight: 400;\n      font-size: 16px;\n    }\n\n    svg {\n      width: 11px;\n      height: 11px;\n      path {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  text-align: center;\n  padding: ", ";\n  border-radius: ", "px;\n  background: ", ";\n  min-height: 229px;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n\n  .category-card-icon {\n    margin-top: 15px;\n    svg path {\n      fill: ", ";\n    }\n  }\n  .category-content {\n    h4 {\n      font-size: 20px;\n      margin-bottom: 22px;\n    }\n  }\n  button {\n    display: flex;\n    align-items: center;\n    margin: 0 auto;\n    * {\n      margin: 0px;\n      color: ", ";\n      font-weight: 400;\n      font-size: 16px;\n    }\n\n    svg {\n      width: 11px;\n      height: 11px;\n      path {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var variant = _a.variant, mobile = _a.mobile;
    return variant === "solid"
        ? "78px 8px 72px"
        : mobile
            ? "75px 8px 97px"
            : "15px 28px 34px 38px";
}, function (_a) {
    var theme = _a.theme;
    return theme.buttonRadius;
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return variant === "gradient"
        ? "#F7F7F7"
        : (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__cardBackgroundColor, theme.cardBackgroundColor);
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.gray2);
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.white);
}, function (_a) {
    var theme = _a.theme;
    return (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.white, theme.white);
});
var CategoryCard = function (props) {
    var icon = props.icon, title = props.title, subtitle = props.subtitle, onButtonClick = props.onButtonClick, variant = props.variant, _a = props.mobile, mobile = _a === void 0 ? false : _a, _b = props.className, className = _b === void 0 ? "" : _b;
    return ((0, jsx_runtime_1.jsxs)(StyledCategoryCard, __assign({ className: "wellms-component ".concat(className), mobile: mobile, variant: variant }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "category-card-icon" }, { children: icon })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "category-content" }, { children: [(0, jsx_runtime_1.jsx)(Title_1.Title, __assign({ as: "h4", level: 2, className: "category-card-title" }, { children: title })), (0, jsx_runtime_1.jsx)(Button_1.Button, __assign({ mode: "secondary", onClick: onButtonClick, style: {
                            marginTop: "6px",
                        } }, { children: subtitle }))] }))] })));
};
exports.CategoryCard = CategoryCard;
var NewCategoryCard = (0, styled_components_1.default)(exports.CategoryCard)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.default = (0, styled_components_1.withTheme)(NewCategoryCard);
var templateObject_1, templateObject_2;
